<script>
  import { _ } from 'svelte-i18n';

  import Sidebar from "./../components/Sidebar.svelte";
</script>

<div>

  <Sidebar>
    <div class="hero min-h-screen">
      <div class="hero-content flex">

        <div class="w-1/2 p-16 relative">
          <h1 class="font-bold text-8xl uppercase"> {$_('base.lets_start')} </h1>
          <h3 class="text-xl text-error font-bold whitespace-nowrap"> {$_('base.select_area')} </h3>
          <img class="absolute left-4" src="/assets/arrow.svg" />
        </div>

        <div class="w-1/2 p-16">
          <img src="/assets/Teacher.svg" />
        </div>

      </div>
    </div>
  </Sidebar>

</div>

